import { t } from '@framework/i18n';
import { Modal, ModalFuncProps, Typography } from 'antd';
import React, { useCallback, useMemo, useRef } from 'react';

const { Paragraph } = Typography;

export interface IUseRepeatControllerConfirmModal {}

/**
 * Modal di conferma per la modifica della lunghezza della lista.
 * Se la lunghezza viene ridotta, vengono rimossi gli elementi in eccesso.
 */
export function useRepeatControllerConfirmModal() {
  const [modal, contextHolder] = Modal.useModal();

  const config: ModalFuncProps = useMemo(() => {
    return {
      title: t(
        'widgets.use-repeat-controller-confirm-modal.title',
        'Rimuovere elementi dalla lista?',
      ),
      content: (
        <Paragraph>
          {t(
            'widgets.use-repeat-controller-confirm-modal.content',
            'Riducendo il numero di elementi, rimuoverai le righe in eccesso dalla lista. Continuare?',
          )}
        </Paragraph>
      ),
      okText: t(
        'widgets.use-repeat-controller-confirm-modal.continue',
        'Continua',
      ),
      cancelText: t(
        'widgets.use-repeat-controller-confirm-modal.cancel',
        'Annulla',
      ),
    };
  }, []);

  const isModalOpenRef = useRef(false);

  const handleModal = useCallback(
    async (params: { onOk: () => void; onCancel: () => void }) => {
      if (isModalOpenRef.current) return;
      isModalOpenRef.current = true;
      await modal.confirm({
        ...config,
        onOk: params.onOk,
        onCancel: params.onCancel,
      });
      isModalOpenRef.current = false;
    },
    [config, modal],
  );

  return { handleModal, contextHolder };
}

export type IRepeatControllerConfirmModal = ReturnType<
  typeof useRepeatControllerConfirmModal
>['handleModal'];
